module.exports = __webpack_public_path__ + "img/ludo-competition_zh.b840f50c.png";